import Senha from '@/views/area/Senha'
import Cadastro from '@/views/area/Cadastro'
import FormView from '@/views/FormView'
import AreaView from '@/views/AreaView'
import Boleto from '@/views/area/Boleto' 
import Envios from '@/views/area/Envios'
import InitalView from '@/views/InitalView'
import Download from '@/views/area/Download'
import Inscricao from '@/views/area/Inscricao'
import Impugnacao from '@/views/area/Impugnacao'
import Restituicao from '@/views/area/Restituicao'
import SolicitarIsencao from '@/views/area/SolicitarIsencao'
import adminRoutes from '@/router/admin'


export default [
  // Rotas administrativas (devem vir primeiro para ter prioridade)
  ...adminRoutes,

  // Home
  { path: '/', component: InitalView, name: 'home' },

  // Form inscrição
  { path: '/formulario', component: FormView, name: 'form' },

  // Area do candidato
  {
    path: '/area-candidato',
    name: 'area-candidato',
    component: AreaView,
    children: [
      { path: 'inscricoes', component: Inscricao, name: 'area-incricao' },
      { path: 'download', component: Download, name: 'area-form' },
      { path: 'solicitar-isencao', component: SolicitarIsencao, name: 'area-solicitar-isencao' },
      { path: 'recursos', component: Impugnacao, name: 'area-recursos' },
      { path: 'envios', component: Envios, name: 'area-envios' },
      { path: 'boleto', component: Boleto, name: 'area-boleto' }, // Nova rota para boletos
      { path: 'restituicao', component: Restituicao, name: 'area-restituicao' },
      { path: 'cadastro', component: Cadastro, name: 'area-cadastro' },
      { path: 'senha', component: Senha, name: 'area-senha' },
 
    ]
  },

  // Rota wildcard deve vir por último
  { path: '*', component: InitalView, name: 'not-found' }
]
